import { render, staticRenderFns } from "./SegmentsDetails.vue?vue&type=template&id=5eecc1ac&scoped=true&"
import script from "./SegmentsDetails.vue?vue&type=script&lang=js&"
export * from "./SegmentsDetails.vue?vue&type=script&lang=js&"
import style0 from "./SegmentsDetails.vue?vue&type=style&index=0&id=5eecc1ac&lang=scss&scoped=true&"
import style1 from "./SegmentsDetails.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5eecc1ac",
  null
  
)

export default component.exports